import { ExternalInteractorBase, isInArray } from "tsparticles-engine";
import { Trail } from "./Options/Classes/Trail";
export class TrailMaker extends ExternalInteractorBase {
  constructor(container) {
    super(container);
    this._delay = 0;
  }
  clear() {}
  init() {}
  async interact(delta) {
    var _interactivity$mouse$, _this$_lastPosition, _interactivity$mouse$2, _this$_lastPosition2;
    const container = this.container,
      {
        interactivity
      } = container;
    if (!container.retina.reduceFactor) {
      return;
    }
    const options = container.actualOptions,
      trailOptions = options.interactivity.modes.trail;
    if (!trailOptions) {
      return;
    }
    const optDelay = trailOptions.delay * 1000 / this.container.retina.reduceFactor;
    if (this._delay < optDelay) {
      this._delay += delta.value;
    }
    if (this._delay < optDelay) {
      return;
    }
    const canEmit = !(trailOptions.pauseOnStop && (interactivity.mouse.position === this._lastPosition || ((_interactivity$mouse$ = interactivity.mouse.position) === null || _interactivity$mouse$ === void 0 ? void 0 : _interactivity$mouse$.x) === ((_this$_lastPosition = this._lastPosition) === null || _this$_lastPosition === void 0 ? void 0 : _this$_lastPosition.x) && ((_interactivity$mouse$2 = interactivity.mouse.position) === null || _interactivity$mouse$2 === void 0 ? void 0 : _interactivity$mouse$2.y) === ((_this$_lastPosition2 = this._lastPosition) === null || _this$_lastPosition2 === void 0 ? void 0 : _this$_lastPosition2.y)));
    const mousePos = container.interactivity.mouse.position;
    if (mousePos) {
      this._lastPosition = {
        ...mousePos
      };
    } else {
      delete this._lastPosition;
    }
    if (canEmit) {
      container.particles.push(trailOptions.quantity, container.interactivity.mouse, trailOptions.particles);
    }
    this._delay -= optDelay;
  }
  isEnabled(particle) {
    var _particle$interactivi;
    const container = this.container,
      options = container.actualOptions,
      mouse = container.interactivity.mouse,
      events = ((_particle$interactivi = particle === null || particle === void 0 ? void 0 : particle.interactivity) !== null && _particle$interactivi !== void 0 ? _particle$interactivi : options.interactivity).events;
    return mouse.clicking && mouse.inside && !!mouse.position && isInArray("trail", events.onClick.mode) || mouse.inside && !!mouse.position && isInArray("trail", events.onHover.mode);
  }
  loadModeOptions(options) {
    if (!options.trail) {
      options.trail = new Trail();
    }
    for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      sources[_key - 1] = arguments[_key];
    }
    for (const source of sources) {
      options.trail.load(source === null || source === void 0 ? void 0 : source.trail);
    }
  }
  reset() {}
}